import {
  UPDATE_SEARCH_DETAILS,
  TOGGLE_SINGLE_FLIGHT,
  TOGGLE_MULTIPLE_DESTINATIONS,
} from '../actions/searchDetails'
import { RECEIVE_AIRPORT_ROUTES } from '../actions/airportRoutes'
import { RESET_FLOW } from '../actions/reset'
import moment, { stringifyDate } from '../helpers/momentUtils'
export const initialState = {
  selectedOutboundDate: stringifyDate(moment().add(1, 'days')),
  selectedInboundDate: stringifyDate(moment().add(7, 'days')),
  isSingleFlight: false,
  isMultipleDestination: false,
  lastSelectedAirport: {},
  primary: {
    outboundAirport: {},
    inboundAirport: {},
    filteredInboundAirports: {},
    filteredOutboundAirports: {},
  },
  secondary: {
    outboundAirport: {},
    inboundAirport: {},
    filteredInboundAirports: {},
    filteredOutboundAirports: {},
  },
}

function searchDetails(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_SEARCH_DETAILS:
    case RECEIVE_AIRPORT_ROUTES:
      return {
        ...state,
        ...action.data,
      }
    case TOGGLE_SINGLE_FLIGHT:
      return {
        ...state,
        isSingleFlight: !state.isSingleFlight,
      }
    case TOGGLE_MULTIPLE_DESTINATIONS:
      return {
        ...state,
        isMultipleDestination: !state.isMultipleDestination,
      }
    case RESET_FLOW:
      return initialState
    default:
      return state
  }
}

export default searchDetails
